import React from 'react'
import BaseIcon from './BaseIcon'
import imgFill from 'assets/img/ic-common-area-fill.png'
import imgLine from 'assets/img/ic-common-area.png'
import imgFillCM from 'assets/img/ic-common-area-fill-cm.png'
import imgLineCM from 'assets/img/ic-common-area-cm.png'

type Props = {
  active?: boolean
  isCM?: boolean
}

const ComonAreaIcon = (props: Props) => {
  const { active = false, isCM = false } = props
  const activeIcon = isCM ? imgFillCM : imgFill
  const inactiveIcon = isCM ? imgLineCM : imgLine
  return (
    <BaseIcon
      active={active}
      activeIcon={activeIcon}
      inactiveIcon={inactiveIcon}
    />
  )
}

export default ComonAreaIcon
